import * as goblin from 'goblin-base';
import { Coord, Guide, Axis, Geom, Legend, Tooltip } from './components/SubComponent';
export { default as Chart } from './components/Chart';
export { Coord, Guide, Axis, Geom, Legend, Tooltip };
export var Global = goblin.Global;
export var Shape = goblin.Shape;
//# sourceMappingURL=index.js.map